export default __webpack_public_path__ + "static/media/no-email.a5c82f46.svg";